/**
 * The run-status vocabulary Harper's surfaces share: chip tone and label per
 * status. `delivery_failed` is the amber honesty case (the filing exists but
 * never reached its reader); `failed` is incident-toned; `nothing_to_file` is
 * muted (a quiet day is a clean answer). `held` waits on capacity and resumes on
 * its own, so it reads flat, never as a failure; `needs_attention` is parked
 * until a person acts (amber); `superseded` was caught up by a later run.
 */
import type { ChipProps } from "../ui/chip.js";

export type HarperRunStatusUi =
  | "in_progress"
  | "completed"
  | "nothing_to_file"
  | "delivery_failed"
  | "failed"
  | "held"
  | "needs_attention"
  | "superseded";

const TONES: Record<HarperRunStatusUi, NonNullable<ChipProps["tone"]>> = {
  in_progress: "accent",
  completed: "success",
  nothing_to_file: "dashed",
  delivery_failed: "honesty",
  failed: "incident",
  held: "neutral",
  needs_attention: "honesty",
  superseded: "dashed",
};

const LABELS: Record<HarperRunStatusUi, string> = {
  in_progress: "running",
  completed: "filed",
  nothing_to_file: "nothing to file",
  delivery_failed: "delivery failed",
  failed: "failed",
  held: "waiting on capacity",
  needs_attention: "needs attention",
  superseded: "caught up later",
};

export function harperRunStatusTone(status: string): NonNullable<ChipProps["tone"]> {
  return TONES[status as HarperRunStatusUi] ?? "neutral";
}

export function harperRunStatusLabel(status: string): string {
  return LABELS[status as HarperRunStatusUi] ?? status;
}
